import { forwardRef, useImperativeHandle, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import PropTypes from 'prop-types';

import { deleteById } from 'apis/proposalPrograms.api';
import { mapError } from 'utils/func';
import { toast } from 'layout';
import { TOAST } from 'constant';

const ConfirmDelete = forwardRef(({ refetch }, ref) => {
  // #region Data
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [programControl, setProgramControl] = useState(null);

  const { mutate } = useMutation(deleteById);
  // #endregion

  // #region Event
  useImperativeHandle(
    ref,
    () => ({
      open: (_programControl) => {
        setProgramControl({ ..._programControl });
        setVisible(true);
      },
    }),
    []
  );

  const handleDeleteProgram = () => {
    if (!programControl?.id) return;
    mutate(programControl?.id, {
      onSuccess: () => {
        toast(TOAST.SUCCESS, t('programProposal.delete.deleteSuccess'));
        setVisible(false);
        refetch();
      },
      onError: (error) => {
        toast(TOAST.ERROR, mapError(t, error));
      },
    });
  };

  const footerConfirmationSubmit = () => (
    <div>
      <Button
        label={t('program.cancel')}
        className="w-7rem"
        severity="danger"
        onClick={() => setVisible(false)}
        autoFocus
      />
      <Button
        label={t('program.ok')}
        className="w-7rem"
        severity="info"
        onClick={handleDeleteProgram}
      />
    </div>
  );
  // #endregion

  return (
    <Dialog
      header={<p className="text-red-500">{t('program.delete.title')}</p>}
      visible={visible}
      position="center"
      style={{ width: '400px' }}
      onHide={() => setVisible(false)}
      draggable={false}
      footer={footerConfirmationSubmit}
    >
      <p className="text-lg font-bold">{programControl?.name}</p>
      <p className="text-lg">{t('program.delete.confirmationDeleteMessage')}</p>
    </Dialog>
  );
});

export default ConfirmDelete;

ConfirmDelete.propTypes = {
  refetch: PropTypes.func.isRequired,
};
